import * as actionTypes from '../actions/actionTypes';

import {
    Purchase,
    IOnlineOrderHistory,
    SyncPurchases,
    IGlobalOrderDetails,
    IRetailOrderHistory,
} from '@interfaces/myPurchasesInterfaces';
import { RequestStatus } from '@interfaces/mainInterfaces';

import { updateObject } from '@utils/utils';

class InitialStateProps {
    //ONLINE ORDERS
    onlineOrders: IOnlineOrderHistory[] = [];
    onlineOrdersRequestStatus: RequestStatus = 'IDLE';
    retailOrdersRequestStatus: RequestStatus = 'IDLE';
    retailOrders: IRetailOrderHistory[] = [];

    encodedOrderId: string = null;
    encryptedOnlineOrderIdRequestStatus: RequestStatus = 'IDLE';

    globalOrderDetails: IGlobalOrderDetails = null;
    globalOrderDetailsRequestStatus: RequestStatus = 'IDLE';

    orderItemCarrierUrl: string = null;
    getOrderItemCarrierUrlRequestStatus: RequestStatus = 'IDLE';

    //IN-STORE PURCHASES
    searchFilters: SyncPurchases = null;
    purchases: Purchase[] = [];
    purchasesRequestStatus: RequestStatus = 'IDLE';

    prescriptionInfoDetails: any;
}

const initialState: InitialStateProps = new InitialStateProps();

const myPurchasesReducer = (state = initialState, action): InitialStateProps => {
    switch (action.type) {
        case actionTypes.GET_ENCRYPTED_ONLINE_ORDER_ID_PENDING:
            return updateObject(state, {
                encryptedOnlineOrderIdRequestStatus: 'LOADING',
            });
        case actionTypes.GET_ENCRYPTED_ONLINE_ORDER_ID_SUCCESS:
            return updateObject(state, {
                encryptedOnlineOrderIdRequestStatus: 'SUCCESS',
                encodedOrderId: action.encodedOrderId,
            });
        case actionTypes.GET_ENCRYPTED_ONLINE_ORDER_ID_ERROR:
            return updateObject(state, {
                encryptedOnlineOrderIdRequestStatus: 'ERROR',
            });
        case actionTypes.GET_ONLINE_ORDERS_HISTORY_PENDING:
            return updateObject(state, {
                onlineOrdersRequestStatus: 'LOADING',
            });
        case actionTypes.GET_ONLINE_ORDERS_HISTORY_SUCCESS:
            return updateObject(state, {
                onlineOrdersRequestStatus: 'SUCCESS',
                onlineOrders: action.onlineOrders,
            });
        case actionTypes.GET_ONLINE_ORDERS_HISTORY_ERROR:
            return updateObject(state, {
                onlineOrdersRequestStatus: 'ERROR',
            });
        case actionTypes.GET_GLOBAL_ONLINE_ORDER_DETAILS_PENDING:
            return updateObject(state, {
                globalOrderDetailsRequestStatus: 'LOADING',
            });
        case actionTypes.GET_GLOBAL_ONLINE_ORDER_DETAILS_SUCCESS:
            return updateObject(state, {
                globalOrderDetailsRequestStatus: 'SUCCESS',
                globalOrderDetails: action.globalOrderDetails,
            });
        case actionTypes.GET_GLOBAL_ONLINE_ORDER_DETAILS_ERROR:
            return updateObject(state, {
                globalOrderDetailsRequestStatus: 'ERROR',
            });
        case actionTypes.GET_ORDER_ITEM_CARRIER_URL_PENDING:
            return updateObject(state, {
                getOrderItemCarrierUrlRequestStatus: 'LOADING',
            });
        case actionTypes.GET_ORDER_ITEM_CARRIER_URL_SUCCESS:
            return updateObject(state, {
                getOrderItemCarrierUrlRequestStatus: 'SUCCESS',
                orderItemCarrierUrl: action.orderItemCarrierUrl,
            });
        case actionTypes.GET_ORDER_ITEM_CARRIER_URL_ERROR:
            return updateObject(state, {
                getOrderItemCarrierUrlRequestStatus: 'ERROR',
            });
        case actionTypes.SAVE_IN_STORE_PURCHASES_SEARCH_FILTERS:
            return updateObject(state, {
                searchFilters: action.searchFilters,
            });
        case actionTypes.GET_IN_STORE_PURCHASES_MY_PURCHASES_PENDING:
            return updateObject(state, {
                purchasesRequestStatus: 'LOADING',
            });
        case actionTypes.GET_IN_STORE_PURCHASES_MY_PURCHASES_SUCCESS:
            return updateObject(state, {
                purchasesRequestStatus: 'SUCCESS',
                purchases: action.purchases,
            });

        case actionTypes.GET_IN_STORE_PURCHASES_MY_PURCHASES_ERROR:
            return updateObject(state, {
                purchasesRequestStatus: 'ERROR',
            });
        case actionTypes.GET_PRESCRIPTION_INFO:
            return updateObject(state, {
                prescriptionInfoDetails: action.prescriptionInfoDetails,
            });
        case actionTypes.GET_ORDER_RETAIL_HISTORY_PENDING:
            return updateObject(state, {
                retailOrdersRequestStatus: 'LOADING',
            });
        case actionTypes.GET_ORDER_RETAIL_HISTORY_ERROR:
            return updateObject(state, {
                retailOrdersRequestStatus: 'ERROR',
            });
        case actionTypes.GET_ORDER_RETAIL_HISTORY_SUCCESS:
            return updateObject(state, {
                retailOrdersRequestStatus: 'SUCCESS',
                retailOrders: action.retailOrders,
            });
        default:
            return state;
    }
};

export default myPurchasesReducer;
